import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    HostBinding,
    inject,
    signal
} from '@angular/core';
import { Store } from '@ngxs/store';
import { DCLCardOptions } from '@portal/clients/dcl-cards/entities/dcl-card.options';
import { InvoiceOptions } from '@portal/invoicing/invoices-cards/entities/invoice-card.options';
import { LoaderService } from '@shared/services/loader.service';
import { PostInvoicesToAADESchema } from '@shared/zigra-schemas/custom/post-invocies-to-aade.schema.service';
import { PostDCLsToAADESchema } from '@shared/zigra-schemas/custom/PostDCLsToAADE.schema.service';
import {
    DigitalClientCardInputType,
    DigitalClientCardGraphQLSchemaActions,
    DigitalClientCardTypeQuery,
    InvoiceInputType,
    InvoiceGraphQLSchemaActions,
    InvoiceTypeQuery,
    InvoiceType,
    ProviderResponseErrorTypeQuery,
    ProviderResponseTypeQuery,
    ResponseTypeErrorTypeQuery,
    AddressTypeQuery,
    CityTypeQuery,
    ContactDetailTypeQuery,
    CourierTypeQuery,
    CustomerTypeQuery,
    DiscountCategoryTypeQuery,
    FirstNameTypeQuery,
    InvoiceDeliveryNoteHeaderTypeQuery,
    InvoiceDetailTypeQuery,
    InvoiceEntitySubjectInfoTypeQuery,
    InvoiceIncomeClassificationTypeQuery,
    InvoiceNoteTypeQuery,
    InvoicePartyTypeQuery,
    InvoicePaymentTypeQuery,
    InvoiceSummaryTypeQuery,
    InvoiceTaxTypeQuery,
    ProductInventoryInfoTypeQuery,
    ProductInvoicingInfoTypeQuery,
    ProductPackageTypeQuery,
    SupplierTypeQuery,
    DigitalClientCardType,
    InvoiceGraphQLSchemaSelectors,
    POSTerminalResponse,
    POSTerminalErrorData,
    POSTerminalTransactionData,
    POSTerminalResponseGraphQLSchemaActions,
    POSTerminalResponseTypeQuery,
    POSTerminalResponseType,
    POSTerminalTransactionDataType,
    POSTerminalErrorDataType,
    UsersActionsTypeQuery,
    POSTerminalErrorDataTypeQuery,
    POSTerminalServiceDataTypeQuery,
    POSTerminalTransactionDataTypeQuery,
    POSTerminalTransactionTypeQuery,
    ProviderSignatureMoreDataTypeQuery,
    ProviderSignatureTypeQuery,
    SignatureInvoiceResponseTypeQuery,
    TAXOfficeTypeQuery,
    POSTerminalResponseGraphQLSchemaSelectors
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import {
    ConfirmationService,
    MessageService,
    ToastMessageOptions
} from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import {
    concatMap,
    finalize,
    from,
    of,
    switchMap,
    takeUntil,
    takeWhile,
    timer,
    zip
} from 'rxjs';
import { ZInvoicePaymentOptionsComponent } from '../../z-invoice-payment-options/z-invoice-payment-options.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConfirmDialog, ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environemnt/environment';
import { ZionMessagesService } from '@shared/services/ax-messages.service';
import { QueryFilter, QueryFilterGroup } from 'zigra-ng-framework';
import { DclCardService } from '@shared/services/dcl-card/dcl-card.service';
import { ZCurrencyPipe } from '@shared/pipes/ZCurrency.pipe';
import { NoAction } from '@shared/zigra-schemas/custom/no-action';

@Component({
    selector: 'zion-invoice-card-footer',
    imports: [
        CommonModule,
        ButtonModule,
        ConfirmDialogModule,
        ConfirmDialog,
        ToastModule
    ],
    templateUrl: './invoice-card-footer.component.html',
    styleUrl: './invoice-card-footer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class InvoiceCardFooterComponent {
    @HostBinding('class') class: string =
        'flex flex-auto flex-wrap justify-content-between';
    visible?: boolean;
    store = inject(Store);
    dclCardService = inject(DclCardService);
    loaderService = inject(LoaderService);
    postDCLsToAADESchema = inject(PostDCLsToAADESchema);
    dialogService = inject(DialogService);
    cd = inject(ChangeDetectorRef);
    private http = inject(HttpClient);

    //private messageService = inject(MessageService);
    private messageService = inject(ZionMessagesService);
    private confirmationService = inject(ConfirmationService);
    private postInvoicesToAADESchema = inject(PostInvoicesToAADESchema);
    protected showSendToAADEButton: boolean = false;
    // protected showAddPaymentButton: boolean = false;
    protected hasInvoiceValidMARK: boolean = false;
    protected canDoPOSTransaction: boolean = false;
    protected correlateInvoice: boolean = false;
    protected allowSave: boolean = false;
    protected totalGrossValue?: number;
    //protected invoice = signal<InvoiceType | undefined>(undefined);

    dialogConfigDataOptions: DynamicDialogConfig<InvoiceOptions> = inject(
        DynamicDialogConfig<InvoiceOptions>
    );

    /**
     *
     */
    constructor() {
        const options = this.dialogConfigDataOptions.data as InvoiceOptions;
        //this.dialogConfigDataOptions.data?.invoiceCardTypeFormGroups;

        //options.onPaymentOption.pipe(takeUntilDestroyed()).subscribe(() => {});
        options.onFetchedInvoice = (options: InvoiceOptions) => {
            this.validateFormButtons();
        };
    }

    /**
     * Get The active Invoice FormGroup based on Selected Tab
     * @returns The active Infoce Form Group
     */
    invoiceFormGroup(tabId?: 'services' | 'products' | 'none' | string) {
        debugger;
        const options = this.dialogConfigDataOptions.data as InvoiceOptions;

        const selectedTabId =
            tabId ?? options?.selectedInvoiceTab?.() ?? 'services';

        console.debug('selectedTabId ', selectedTabId);

        switch (selectedTabId) {
            case 'services':
            case 'none':
                return options.invoiceCardTypeFormGroups?.[0];
        }

        return options.invoiceCardTypeFormGroups?.[1];
    }

    validateFormButtons() {
        debugger;
        const options = this.dialogConfigDataOptions.data as InvoiceOptions;

        const invoice = this.invoiceFormGroup()?.getRawValue() as
            | InvoiceType
            | undefined; // (options.selectedInvoiceTab?.() == 'services' ? options.invoiceCardTypeFormGroups?.[0] : options.invoiceCardTypeFormGroups?.[1])?.getRawValue() as InvoiceType | undefined

        console.debug('invoice: ', invoice?._id);

        //options.selectedInvoiceTab;
        this.showSendToAADEButton = false;
        this.hasInvoiceValidMARK = false;
        this.canDoPOSTransaction = false;
        this.correlateInvoice = false;
        this.allowSave = false;

        this.totalGrossValue = invoice?.Summaries?.[0]?.TotalGrossValue;

        // Αν έρθει από το κουμπάκι ΄Έξοδος Οχήματος' και δεν υπάρχει ΜΑΡΚ.
        // Το ότι δεν υπάρχει ΜΑΡΚ το γνωρίζει ήδη η κάρτα Εγγραφής Ψηφιακού Πελατολογίου, η οποία στέλνει το Flag sourceModal = true
        // this.showAddPaymentButton = options.sourceModal != true;

        // Για να σταλεί στην Α.Α.Δ.Ε θα πρέπει να υπάρχει Τουλάχιστον Μια επιλογή πληρωμής ή να έχει γίνει Initiate η φόρμα από το Modal της εγγραφής του ψηφιακού πελατολογίου!!!!
        if (
            // (this.invoice()?.Payments?.[0]?.Type != undefined ||
            //     options.sourceModal == true) &&
            invoice?.Response?.StatusCode?.toLocaleLowerCase() !=
                'Success'?.toLocaleLowerCase() &&
            (invoice?.Response?.InvoiceMark == undefined ||
                invoice?.Response?.InvoiceMark == 0) //  εδώ το InvoiceMark μπορεί να είναι 0 όταν είναι πληρωμή με κάρτα και ο πάροχος έχει επιστρέψει signatures
        ) {
            // Στην Α.Α.Δ.Ε μπορούμε να στείλουμε ξανά αν είμαστε στη φάση της πληρωμής με κάρτα και δεν έχουμε κάνει ακόμα πληρωμή.
            // Αυτό είναι χρήσιμο στη περίπτωση που ο πελάτης δεν μπορεί να πληρώσει με κάρτα, οπότε πρέπει να εκδόσουμε το παραστατικό εκ νέου
            // με άλλο τρόπο πληρωμής.
            this.showSendToAADEButton = true;
        }

        if (
            invoice?.Response?.StatusCode?.toLocaleLowerCase() ==
                'Success'?.toLocaleLowerCase() &&
            invoice?.Response?.InvoiceMark != undefined &&
            invoice?.Response?.InvoiceMark != 0
        ) {
            this.hasInvoiceValidMARK = true;
            // this.showAddPaymentButton = false;

            if (
                invoice?.Payments?.[0]?.Type == 7 ||
                (invoice?.Payments?.[0]?.Type == 5 &&
                    invoice?.Payments?.[0]?.Type07 == true)
            ) {
                const lastPOSTransaction =
                    this.getLastOnSalePOSTransaction(invoice);

                debugger;
                // Εάν η τελευταία SuccessDate του τύπου Operation == '/sale' δεν έχει ολοκληρωθεί,
                // τότε επέτρεψε στον χρήστη να στείλει αίτημα στο τερματικό για πληρωμή.
                if (lastPOSTransaction?.SuccessDate == undefined) {
                    this.canDoPOSTransaction = true;
                }
            }
        }

        if (
            (invoice?.Response?.StatusCode ?? '') == '' &&
            invoice?.Response?.InvoiceMark == 0 &&
            invoice?.Payments?.[0]?.Type == 7
        ) {
            const lastPOSTransaction =
                this.getLastOnSalePOSTransaction(invoice);

            debugger;
            // Εάν η τελευταία SuccessDate του τύπου Operation == '/sale' δεν έχει ολοκληρωθεί,
            // τότε επέτρεψε στον χρήστη να στείλει αίτημα στο τερματικό για πληρωμή.
            if (lastPOSTransaction?.SuccessDate == undefined) {
                this.canDoPOSTransaction = true;
            }
        }

        debugger;
        if (
            this.hasInvoiceValidMARK == true &&
            invoice?.DigitalClientCardId != undefined
        ) {
            this.correlateInvoice =
                invoice?.DCLCorrelationResponse?.StatusCode?.toLocaleLowerCase() !=
                'Success'.toLocaleLowerCase();
        }

        if (
            invoice?.Response?.InvoiceMark == undefined ||
            (invoice?.Response?.InvoiceMark == 0 &&
                invoice?.Response?.StatusCode?.toLocaleLowerCase() !=
                    'Success'?.toLocaleLowerCase())
        )
            this.allowSave = true;

        //if (options.mode == 'add') {}

        this.cd.detectChanges();
    }

    private getLastOnSalePOSTransaction(invoice?: InvoiceType) {
        // ΠΡΟΣΟΧΗ: Μπορεί να είναι πολλά POSTransactions γιατί μπορεί ο χρήστης να πατάει
        // συνέχεια το κουμπάκι 'Διαβίβαση Παραστατικού' οπότε το σύστημα δημιουργεί πολλά POSTransactions
        // αν και διαγράφει τα προηγούμενα.
        // TODO: (2025/06/29) Δεν πρέπει να διαγράφει τα προηγούμενα, αλλά να τα ακυρώνει!!!

        const lastPOSTransaction = invoice?.POSTransactions?.filter(
            (transaction) => transaction.Operation == '/sale'
        ).sort((a, b) => {
            if (
                a.UsersActions?.CreatedDate == undefined ||
                b.UsersActions?.CreatedDate == undefined
            )
                return 0;

            return new Date(a.UsersActions?.CreatedDate) <
                new Date(b.UsersActions?.CreatedDate)
                ? -1
                : 1; // 1: DESC, -1: ASC
        });

        return lastPOSTransaction?.[0];
    }

    onSave(doSelectPaymentOption?: boolean) {
        debugger;
        const options = this.dialogConfigDataOptions.data as InvoiceOptions;

        //     options.invoiceCardTypeFormGroup?.controls?.CounterPart?.controls?.Address?.controls?.PostalCode?.setValue(
        //   options.invoiceCardTypeFormGroup?.controls?.CounterPart
        //     ?.controls?.Address?.controls?.PostalCode?.value ??
        //     this.invoice()?.Customer?.Addresses?.[0]?.PostalCode,
        // );

        // options.invoiceCardTypeFormGroup?.controls?.CounterPart?.controls?.Address?.controls?.CityEx?.setValue(
        //   options.invoiceCardTypeFormGroup?.controls?.CounterPart
        //     ?.controls?.Address?.controls?.CityEx?.value ??
        //     this.invoice()?.Customer?.Addresses?.[0]?.CityEx ??
        //     this.invoice()?.Customer?.Addresses?.[0]?.City?.Title,
        // );

        // options.invoiceCardTypeFormGroup?.controls?.CounterPart?.controls?.Address?.controls?.StreetName?.setValue(
        //   options.invoiceCardTypeFormGroup?.controls?.CounterPart
        //     ?.controls?.Address?.controls?.StreetName?.value ??
        //     this.invoice()?.Customer?.Addresses?.[0]?.StreetName,
        // );

        // options.invoiceCardTypeFormGroup?.controls?.CounterPart?.controls?.Address?.controls?.StreetNumber?.setValue(
        //   options.invoiceCardTypeFormGroup?.controls?.CounterPart
        //     ?.controls?.Address?.controls?.StreetNumber?.value ??
        //     this.invoice()?.Customer?.Addresses?.[0]?.StreetNumber,
        // );

        // const invoice =
        //     options.invoiceCardTypeFormGroup?.getRawValue() as InvoiceInputType;

        // console.debug('Invoice Card - onSave: ', {
        //     invoice: invoice,
        //     invoiceCardTypeFormGroup: options.invoiceCardTypeFormGroup
        // });

        this.loaderService.showAwaitDataSaveLoader();

        // Post and save both of the invoices
        const invoice =
            options.invoiceCardTypeFormGroups?.[0]?.getRawValue() as InvoiceInputType;

        const invoice2 =
            options.invoiceCardTypeFormGroups?.[1]?.getRawValue() as InvoiceInputType;

        debugger;
        // validate dispatch datetime for delivery notes
        if (invoice != undefined) {
            // invoice.DispatchDate = undefined;
            // invoice.IsDeliveryNote = undefined;
            if (
                invoice.TypeCode == '9.3' ||
                invoice.TypeCode == '1.1' ||
                invoice.TypeCode == '1.1-9.3'
            ) {
                invoice.DispatchDate = invoice.DispatchDate ?? new Date();
            } else {
                invoice.DispatchDate = undefined;
                invoice.IsDeliveryNote = undefined;
            }
        }

        if (
            (invoice.Response?.InvoiceMark ?? 0) == 0 &&
            (invoice2?.Response?.InvoiceMark ?? 0) == 0
        ) {
            this.store
                .dispatch([
                    new InvoiceGraphQLSchemaActions.Upsert(
                        invoice,
                        undefined,
                        queryForBatch
                    )
                ])
                .pipe(
                    concatMap(() => {
                        const invoice = this.store.selectSnapshot(
                            InvoiceGraphQLSchemaSelectors.UpsertSelector('', '')
                        )?.data?.Upsert;

                        if (invoice2 == undefined)
                            return of([invoice, invoice2]); // to invoice θα γυρίσει undefined αλλά είμαστε οκ γιατί έχουμε μονο ένα παραστατικό.

                        return zip([
                            this.store.dispatch(
                                new InvoiceGraphQLSchemaActions.Upsert(
                                    invoice2,
                                    undefined,
                                    queryForBatch
                                )
                            ),
                            of(invoice)
                        ]).pipe(
                            concatMap((value) => {
                                const invoice2 = this.store.selectSnapshot(
                                    InvoiceGraphQLSchemaSelectors.UpsertSelector(
                                        '',
                                        ''
                                    )
                                )?.data?.Upsert;
                                return of([value[1], invoice2]);
                            })
                        );
                    }),
                    finalize(() => this.loaderService.dismissAwaitLoader())
                )
                .subscribe((updatedInvoices) => {
                    // Θέλουμε το Observable γιατί πρώτα πρέπει να γίνουν save τα παραστατικά, να ενημερωθεί το Modal και μετά να προχωρήσουμε.
                    debugger;
                    options
                        .onRefreshInvoices?.(options, updatedInvoices)
                        .subscribe(() => {
                            if (doSelectPaymentOption != true)
                                options.onSave?.(options);
                            else this.selectPaymentOption(true);
                        });
                });
        } else {
            if (
                (invoice.Response?.InvoiceMark ?? 0) > 0 &&
                (invoice2?.Response?.InvoiceMark ?? 0) == 0
            ) {
                if (invoice2 != undefined) {
                    this.store
                        .dispatch([
                            new InvoiceGraphQLSchemaActions.Upsert(
                                invoice2,
                                undefined,
                                queryForBatch
                            )
                        ])
                        .pipe(
                            concatMap(() => {
                                const invoice2 = this.store.selectSnapshot(
                                    InvoiceGraphQLSchemaSelectors.UpsertSelector(
                                        '',
                                        ''
                                    )
                                )?.data?.Upsert;

                                return zip([of(invoice), of(invoice2)]);
                            }),
                            finalize(() =>
                                this.loaderService.dismissAwaitLoader()
                            )
                        )
                        .subscribe((updatedInvoices) => {
                            // Θέλουμε το Observable γιατί πρώτα πρέπει να γίνουν save τα παραστατικά, να ενημερωθεί το Modal και μετά να προχωρήσουμε.
                            options
                                .onRefreshInvoices?.(options, updatedInvoices)
                                .subscribe(() => {
                                    if (doSelectPaymentOption != true)
                                        options.onSave?.(options);
                                    else this.selectPaymentOption(true);
                                });
                        });
                }
            } else {
                if (
                    (invoice.Response?.InvoiceMark ?? 0) == 0 &&
                    (invoice2?.Response?.InvoiceMark ?? 0) > 0
                ) {
                    this.store
                        .dispatch([
                            new InvoiceGraphQLSchemaActions.Upsert(
                                invoice,
                                undefined,
                                queryForBatch
                            )
                        ])
                        .pipe(
                            concatMap(() => {
                                const invoice = this.store.selectSnapshot(
                                    InvoiceGraphQLSchemaSelectors.UpsertSelector(
                                        '',
                                        ''
                                    )
                                )?.data?.Upsert;

                                return zip([of(invoice), of(invoice2)]);
                            }),
                            finalize(() =>
                                this.loaderService.dismissAwaitLoader()
                            )
                        )
                        .subscribe((updatedInvoices) => {
                            // Θέλουμε το Observable γιατί πρώτα πρέπει να γίνουν save τα παραστατικά, να ενημερωθεί το Modal και μετά να προχωρήσουμε.
                            options
                                .onRefreshInvoices?.(options, updatedInvoices)
                                .subscribe(() => {
                                    if (doSelectPaymentOption != true)
                                        options.onSave?.(options);
                                    else this.selectPaymentOption(true);
                                });
                        });
                }
            }
        }

        // this.store
        //     .dispatch([
        //         new InvoiceGraphQLSchemaActions.Upsert(
        //             options.invoiceCardTypeFormGroups?.[0]?.getRawValue() as InvoiceInputType,
        //             undefined,
        //             InvoiceTypeQuery.GQLQuery()
        //         ),
        //         new InvoiceGraphQLSchemaActions.Upsert(
        //             options.invoiceCardTypeFormGroups?.[1]?.getRawValue() as InvoiceInputType,
        //             undefined,
        //             InvoiceTypeQuery.GQLQuery()
        //         )
        //     ])
        //     .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
        //     .subscribe(() => {
        //         debugger;
        //         options.onSave?.(options);
        //     });
    }

    /**
     * Επιλογή πληρωμής
     * @param sendToAADE True αν θελουμε να σταλεί το παραστατικό στην Α.Α.Δ.Ε με το πέρας της επιλογής πληρωμής.
     */
    selectPaymentOption(sendToAADE?: boolean) {
        debugger;
        const options = this.dialogConfigDataOptions.data as InvoiceOptions;

        const paymentOptionsDialogRef =
            this.dialogService.open<ZInvoicePaymentOptionsComponent>(
                ZInvoicePaymentOptionsComponent,
                {
                    modal: true,
                    closable: true,
                    width: '450px',
                    height: '630px',
                    draggable: true,
                    maximizable: false,
                    focusOnShow: false,
                    header: 'Τρόπος Πληρωμής',
                    data: {
                        invoiceCardTypeFormGroup:
                            options.invoiceCardTypeFormGroups,
                        invoiceCardTypeFormGroups:
                            options.invoiceCardTypeFormGroups,
                        selectedInvoiceTab: options.selectedInvoiceTab,
                        dclCard: options.dclCard,
                        dclId: options.dclId,
                        mode: options.mode,
                        sourceModal: options.sourceModal,
                        onPaymentOption: (
                            options: InvoiceOptions,
                            paymentType: number
                        ) => {
                            debugger;
                            paymentOptionsDialogRef.close();
                            const invoice =
                                this.invoiceFormGroup()?.getRawValue() as
                                    | InvoiceType
                                    | undefined;

                            // this.invoice.set(
                            //     this.invoiceFormGroup()?.getRawValue() as InvoiceType // options.invoiceCardTypeFormGroups?.getRawValue() as InvoiceType
                            // );
                            this.validateFormButtons();

                            // Αν ο χρήστης έχει έρθει στην επιλογή Πληρωμής από το κουμπάκι που λέει 'Έκδοση/Διαβίβαση Παραστατικού'
                            // το οποίο κουμπάκι εμφανίστηκε όταν ο χρήστης επέλεξε το κουμπάκι 'Εξοδος Οχήματος' από τη κάρτα Μεταβολή Εγγραφής Ψηφιακού Πελατολογίου,
                            // τότε θα πρέπει να επαναληφθεί η διαβίβαση με την επιλογή της πληρωμής.
                            if (sendToAADE == true)
                                this.SendToAADE(invoice, true);

                            this.cd.detectChanges();
                        }
                    }
                } as DynamicDialogConfig<InvoiceOptions>
            );
    }

    /**
     * Εδώ είναι η loopα που περιμένει το UI να ολοκληρωθεί η συναλλαγή του τερματικού. Περιμένει για 20 * 2000 Sec =  40 Secs.
     * Δεν στέλνετε κάτι στο τερματικό από εδώ. Το Zilioo ECR Service είναι αυτό που κάνει τα πάντα. Εδώ απλά περιμένει μια απάντηση στη βάση.
     * @param invoice
     * @returns
     */
    doPOSTransaction(invoice?: InvoiceType) {
        debugger;
        invoice =
            invoice ?? (this.invoiceFormGroup()?.getRawValue() as InvoiceType);

        const lastSalePOSTransaction =
            this.getLastOnSalePOSTransaction(invoice);

        // Εάν η τελευταία SuccessDate του τύπου Operation == '/sale' δεν έχει ολοκληρωθεί,
        // τότε επέτρεψε στον χρήστη να στείλει νέο αίτημα στο τερματικό για πληρωμή.
        if (lastSalePOSTransaction?.SuccessDate != undefined) {
            return;
        }

        this.loaderService.showAwaitDataSaveLoader(
            'Επικοινωνία με Τερματικό (POS)'
        );

        const options = this.dialogConfigDataOptions.data as InvoiceOptions;

        //'yyyyMMddHHmmSS'
        // const dateTimeProviderSignature = `${signatureCreatedDate.getFullYear()}${twoDigits(
        //     signatureCreatedDate.getMonth()
        // )}${twoDigits(signatureCreatedDate.getDate())}${twoDigits(signatureCreatedDate.getHours())}${twoDigits(signatureCreatedDate.getMinutes())}${twoDigits(signatureCreatedDate.getSeconds())}`;

        // // https://www.npmjs.com/package/uuid
        // const uniqueTxnId = uuidv4().replaceAll('-', '');

        const signature = this.hex2Base64(
            lastSalePOSTransaction?.TransactionData?.Signature ?? ''
        );

        const uniqueIntegratorId =
            environment.production != true
                ? '8ae379dfd80a40fcb604ce772c3f5440'
                : undefined;

        debugger;

        const amountTokens =
            lastSalePOSTransaction?.TransactionData?.Amount?.split('.');
        const amount = `${amountTokens?.[0] ?? '0'}.${(amountTokens?.[1] ?? '00').padEnd(2, '0')}`;
        // const posData = {
        //     serviceData: {
        //         host: lastSalePOSTransaction?.ServiceData?.Host, // POSTerminal?.IP, // 'virtualpos.services.novidea.gr',
        //         port: lastSalePOSTransaction?.ServiceData?.Port, //POSTerminal?.Port, // '4000',
        //         ecrid: lastSalePOSTransaction?.ServiceData?.ECRId // POSTerminal?.TerminalId // '80531138'
        //     },
        //     transactionData: {
        //         firstByteOriginalTrans: '0',
        //         uniqueTxnId:
        //             lastSalePOSTransaction?.TransactionData?.UniqueTxnId?.replaceAll(
        //                 '-',
        //                 ''
        //             ), // uniqueTxnId, //'2e878689f6cf4f50faf99c6e4e24b827', <---
        //         uniqueIntegratorId: uniqueIntegratorId, // TODO: Αυτό να φύγει στη παραγωγή!!!! <---
        //         amount: amount, //lastSalePOSTransaction?.TransactionData?.Amount, //totalGrossValue.toFixed(2),
        //         signature: signature,
        //         //'MEQCIHsYkPbv6lpfFKAXY6tMKuY8NOzZD9Aj4q187SP8wdlNAiBd2oV5/zbmxtyyRa0jU48CavA1P0PMsPurGoQEoKGfRA==',
        //         // https://www.aade.gr/mydata/adeiodotimena-logismika-parohon-ilektronikis-timologisis
        //         // Το 005 είναι ο κωδικός που έχει η NOVUS CONCEPTUS Ο.Ε
        //         providersId: '5', //`${POSTerminal?.NSPId}`, // '1122', // add 500 for production validation <---
        //         uniqueEntryNumber:
        //             lastSalePOSTransaction?.TransactionData?.UniqueEntryNumber, // data[1], //invoiceMARK, //'400001952023970',
        //         uid: lastSalePOSTransaction?.TransactionData?.UID, //data[0], // invoiceUid, // '',
        //         dateTimeProviderSignature:
        //             lastSalePOSTransaction?.TransactionData
        //                 ?.DateTimeProviderSignature, // data[2], //dateTimeProviderSignature,
        //         amountPayable:
        //             lastSalePOSTransaction?.TransactionData?.AmountPayable, // data[5],
        //         netValue: lastSalePOSTransaction?.TransactionData?.NetValue, //data[3], // '0', //'',
        //         vatValue: lastSalePOSTransaction?.TransactionData?.VatValue, //data[4], //'0', //'',
        //         totalValue: lastSalePOSTransaction?.TransactionData?.TotalValue, //data[6],
        //         eftTerminalId: lastSalePOSTransaction?.ServiceData?.ECRId, //data[7], //POSTerminal?.TerminalId, //'80531138',
        //         posId: lastSalePOSTransaction?.ServiceData?.ECRId, //data[7], //POSTerminal?.TerminalId, //'80531138',
        //         ecrId: lastSalePOSTransaction?.ServiceData?.ECRId //data[7] //POSTerminal?.TerminalId //'80531138'
        //     }
        // };

        // const postData2 = {
        //     serviceData: {
        //         host: 'virtualpos.services.novidea.gr',
        //         port: '4000',
        //         ecrid: '80531138'
        //     },
        //     transactionData: {
        //         firstByteOriginalTrans:
        //             '0',
        //         uniqueTxnId:
        //             '3320816fcaff41aa022a888d5732c258',
        //         uniqueIntegratorId:
        //             '8ae379dfd80a40fcb604ce772c3f5440',
        //         amount: '1.00'
        //     }
        // };

        //const salesURI = `http://localhost:8080/sale`;

        //const salesURI = `http://192.168.100.222:8080/sale`;
        const salesURI = `${lastSalePOSTransaction?.ServiceData?.ECR2EFTWebServerIP ?? 'http://localhost:8080'}/sale`; //`http://192.168.100.246:8080/sale`;
        // console.debug('doPOSTransaction. Sending posData to Terminal', {
        //     salesURI,
        //     posData
        // });
        const groupQuery = {
            GroupQuery: QueryFilterGroup.JoinWithOrOperator([
                QueryFilterGroup.FieldIsEqualToObjectId<POSTerminalResponseType>(
                    ['TransactionId'],
                    lastSalePOSTransaction?._id ?? '000000000000000000000000'
                )
            ])
        };

        // Εδώ είναι η loopα που περιμένει το UI να ολοκληρωθεί η συναλλαγή του τερματικού. Περιμένει για 20 * 2000 Sec =  40 Secs
        // Δεν στέλνετε κάτι στο τερματικό από εδώ. Το Zilioo ECR Service είναι αυτό που κάνει τα πάντα. Εδώ απλά περιμένει μια απάντηση στη βάση.
        // Collections: pos_terminals_transactions, pos_terminals_responses
        timer(0, 2000)
            .pipe(
                takeWhile((index) => index < 60),
                switchMap((value, index) => {
                    console.debug(
                        'calling POSTerminalResponseGraphQLSchemaActions.Fetch for TransactionId ',
                        lastSalePOSTransaction?._id ??
                            '000000000000000000000000'
                    );
                    return this.store.dispatch(
                        new POSTerminalResponseGraphQLSchemaActions.Fetch(
                            POSTerminalResponseTypeQuery.GQLQuery({
                                TransactionData:
                                    POSTerminalTransactionDataTypeQuery.GQLQuery()
                            }),
                            groupQuery
                        )
                    );
                }),
                takeWhile((value, index) => {
                    const response = this.store.selectSnapshot(
                        POSTerminalResponseGraphQLSchemaSelectors.FetchSelector(
                            '',
                            ''
                        )
                    );
                    const posTerminalResponse = response?.data?.Fetch?.[0];
                    console.debug(
                        'Validate POSTerminalResponseGraphQLSchemaActions.Fetch response for TransactionId ',
                        lastSalePOSTransaction?._id ??
                            '000000000000000000000000',
                        posTerminalResponse
                    );

                    if (posTerminalResponse != null) {
                        const response = this.store.selectSnapshot(
                            POSTerminalResponseGraphQLSchemaSelectors.FetchSelector(
                                '',
                                ''
                            )
                        );
                        const posTerminalResponse = response?.data?.Fetch?.[0];
                        const transactionData =
                            posTerminalResponse?.TransactionData;
                        const error =
                            posTerminalResponse?.Error == undefined
                                ? undefined
                                : posTerminalResponse.Error;

                        console.debug(
                            'POSTerminalResponseGraphQLSchemaActions.Fetch Response for TransactionId ',
                            lastSalePOSTransaction?._id ??
                                '000000000000000000000000',
                            posTerminalResponse
                        );

                        debugger;
                        if (
                            transactionData?.ResponseCodeMessage?.toLocaleLowerCase() ==
                                'Approved'.toLocaleLowerCase() &&
                            error == undefined
                        ) {
                            this.messageService.add({
                                detail: 'Η Πληρωμή ολοκληρώθηκε επιτυχώς',
                                summary: 'Αποδοχή Πληρωμής',
                                severity: 'success',
                                key: 'br'
                            } as ToastMessageOptions);
                        } else {
                            console.error('Η Πληρωμή Απέτυχε', value);
                            if (error != undefined)
                                this.messageService.add({
                                    detail: `Η Πληρωμή Απέτυχε. ${error} - ${transactionData?.ResponseCodeMessage ?? ''} (${transactionData?.MsgCode ?? ''})`,
                                    summary: 'Αποδοχή Πληρωμής',
                                    severity: 'error',
                                    key: 'br'
                                } as ToastMessageOptions);
                            else
                                this.messageService.add({
                                    detail: `Η Πληρωμή Απέτυχε. ${transactionData?.ResponseCodeMessage ?? ''} (${transactionData?.MsgCode ?? ''})`,
                                    summary: 'Αποδοχή Πληρωμής',
                                    severity: 'error',
                                    key: 'br'
                                } as ToastMessageOptions);
                        }

                        timer(100).subscribe(() => {
                            // Refresh Invoice Card Data
                            options.onDoPOSTransaction?.(
                                options,
                                lastSalePOSTransaction,
                                posTerminalResponse
                            );
                        });
                    }
                    return posTerminalResponse == null;
                }),
                finalize(() => {
                    this.loaderService.dismissAwaitLoader();
                    if (invoice) options.onRefreshDCLCards?.();
                })
            )
            .subscribe((value) => {
                const lastResponse = this.store.selectSnapshot(
                    POSTerminalResponseGraphQLSchemaSelectors.FetchSelector(
                        '',
                        ''
                    )
                );
                console.debug(
                    'retreiving POS Transaction Info Response - Subscription Completed ',
                    lastResponse
                );
            });

        // let doLoop = true;
        // while(doLoop) {
        //     //this.store.dispatch(new POSTermianlR)
        //     doLoop = false;
        // }
        if (salesURI == salesURI) return;

        // this.http
        //     .post<any>(salesURI, posData)
        //     .pipe(
        //         concatMap((value) => {
        //             console.debug('response from POS', {
        //                 POSResponse: value,

        //                 POSPayload: posData,
        //                 AskSignatureForOldInvoice: lastSalePOSTransaction
        //             });
        //             debugger;
        //             const transactionData = value.transactionData;
        //             value.error =
        //                 value.error == 'null' || value.error == null
        //                     ? undefined
        //                     : value.error;

        //             const POSResponse: POSTerminalResponseType = {
        //                 MsgType: transactionData.msgType,
        //                 TransactionId: lastSalePOSTransaction?._id,
        //                 Error: value.error
        //                     ? ({
        //                           ErrMessage: value.error?.toString()
        //                       } as POSTerminalErrorDataType)
        //                     : undefined,
        //                 TransactionData: {
        //                     MsgType: transactionData.msgType, //'210',
        //                     PaymentSpecs: transactionData.paymentSpecs, //'P@1',
        //                     Signature: transactionData.signature, //'MEUCIEE6aOBxR9dpi0Ql4+LdDQXBeaMGdMR/o9PlOidIbUKpAiEA8ehaisakcTHi9q3/7G2kwgEj8Abr9RmBK4+vNUaHIQc=',
        //                     City: transactionData.city, //'AMAROYSION',
        //                     AuthorizationCode:
        //                         transactionData.authorizationCode, //'237970',
        //                     MsgOptions: this.parseStringToLong(
        //                         transactionData.msgOptions?.toString()
        //                     ), //'0003',
        //                     AmountPayable: transactionData.amountPayable, //'904',
        //                     MID: transactionData.mid, //'550719917',
        //                     CardExpiryDate: this.parseStringToLong(
        //                         transactionData.cardExpiryDate?.toString()
        //                     ), //'261130',
        //                     TxnDateTime: this.parseStringToLong(
        //                         transactionData.txnDateTime?.toString()
        //                     ), //'20250621191910',
        //                     ResponseCodeMessage:
        //                         transactionData.responseCodeMessage, //'Approved',
        //                     MerchantName: transactionData.merchantName, //'Zion Software I.K.E',
        //                     ResponseCode: transactionData.responseCode, //'00',
        //                     UniquePaymentIdECR:
        //                         transactionData.uniquePaymentIdECR, //'026;000001;000009;237970',
        //                     PosId: transactionData.posId, //'80531138',
        //                     ReferenceNumber: this.parseStringToLong(
        //                         transactionData.referenceNumber?.toString()
        //                     ), //'001009',
        //                     SN: transactionData.sn, //'1640000000',
        //                     ApplicationName: transactionData.applicationName, //'Debit Mastercard',
        //                     AcquirerName: transactionData.acquirerName, //'WORLDLINE/EUROBANK',
        //                     MsgCode: transactionData.msgCode, //'00',
        //                     BatchNumber: this.parseStringToLong(
        //                         transactionData.batchNumber?.toString()
        //                     ), // '001',
        //                     Amount: transactionData.amount, //'9.04',
        //                     Address: transactionData.address, //'AGIOY KONSTANTINOY 50 MAROYSI',
        //                     EFTTerminalId: transactionData.eftTerminalId, //'80531138',
        //                     //length: transactionData.length, //'0494',
        //                     CardType: transactionData.cardType, //'MASTERCARD',
        //                     SessionId: transactionData.sessionId, //'000440',
        //                     AccountNumber: transactionData.accountNumber, //'5581 21** **** 2451',
        //                     NumberOfPostdatedInstallments:
        //                         this.parseStringToLong(
        //                             transactionData.numberOfPostdatedInstallments
        //                         ), //'0000',
        //                     TC: transactionData.tc, //'03000000303000',
        //                     Token: this.parseStringToLong(
        //                         transactionData.token
        //                     ), //'',
        //                     TransactionType: transactionData.transactionType, //'SALE',
        //                     BankId: this.parseStringToLong(
        //                         transactionData.bankId ?? '0'
        //                     ), //'026',
        //                     Go4moreProducts: transactionData.go4moreProducts, //'',
        //                     NumberOfInstallments: this.parseStringToLong(
        //                         transactionData.numberOfInstallments
        //                     ), //'',
        //                     TlvData: transactionData.tlvData, //'TL0022TN00TT1420250621191910',
        //                     Phone: transactionData.phone, //'6971234567',
        //                     UniquePaymentId: transactionData.uniquePaymentId, //'026;000001;000009;237970',
        //                     PosTerminalVersion:
        //                         transactionData.posTerminalVersion, //'2.1.4',
        //                     AID: transactionData.aid, //'A00000000430600',
        //                     ECRToken: transactionData.ecrToken //''
        //                 } as POSTerminalTransactionDataType
        //             } as POSTerminalResponseType;

        //             // this.postInvoicesToAADESchema.CompletionAskSignatureForOldInvoice()
        //             if (
        //                 transactionData.responseCodeMessage?.toLocaleLowerCase() ==
        //                     'Approved'.toLocaleLowerCase() &&
        //                 value.error == undefined
        //             ) {
        //                 this.messageService.add({
        //                     detail: 'Η Πληρωμή ολοκληρώθηκε επιτυχώς',
        //                     summary: 'Αποδοχή Πληρωμής',
        //                     severity: 'success',
        //                     key: 'br'
        //                 } as ToastMessageOptions);
        //             } else {
        //                 console.error('Η Πληρωμή Απέτυχε', value);
        //                 if (value.error != undefined)
        //                     this.messageService.add({
        //                         detail: `Η Πληρωμή Απέτυχε. ${value.error} - ${transactionData?.responseCodeMessage ?? ''} (${transactionData?.msgCode ?? ''})`,
        //                         summary: 'Αποδοχή Πληρωμής',
        //                         severity: 'error',
        //                         key: 'br'
        //                     } as ToastMessageOptions);
        //                 else
        //                     this.messageService.add({
        //                         detail: `Η Πληρωμή Απέτυχε. ${transactionData?.responseCodeMessage ?? ''} (${transactionData?.msgCode ?? ''})`,
        //                         summary: 'Αποδοχή Πληρωμής',
        //                         severity: 'error',
        //                         key: 'br'
        //                     } as ToastMessageOptions);
        //             }

        //             // TODO: Πρέπει να δούμε τι θα κάνουμε στη περίπτωση που έχει ολοκληρωθεί επιτυχώς η συναλλαγή,
        //             //       έχει χρεωθεί ο πελάτης, αλλά δεν ολοκληρώθηκε επιτυχώς η δική μας POSTerminalResponseGraphQLSchemaActions.Upsert κλήση!!!
        //             debugger;
        //             return this.store
        //                 .dispatch(
        //                     new POSTerminalResponseGraphQLSchemaActions.Upsert(
        //                         POSResponse,
        //                         undefined,
        //                         POSTerminalResponseTypeQuery.GQLQuery()
        //                     )
        //                 )
        //                 .pipe(
        //                     concatMap((value) => {
        //                         debugger;
        //                         timer(300).subscribe(() => {
        //                             // Refresh Invoice Card Data
        //                             options.onDoPOSTransaction?.(
        //                                 options,
        //                                 lastSalePOSTransaction,
        //                                 POSResponse
        //                             );
        //                         });

        //                         return of(POSResponse);
        //                     })
        //                 );
        //         }),
        //         finalize(() => {
        //             this.loaderService.dismissAwaitLoader();
        //             // Refresh DCL Cards Table
        //             if (invoice) options.onRefreshDCLCards?.();
        //         })
        //     )
        //     .subscribe();
    }

    private parseStringToLong(value: string | undefined) {
        value = (value ?? '').toString().trim();
        if (
            value == 'null' ||
            value == undefined ||
            value == '' ||
            value == null
        ) {
            return 0;
        }

        const longValue = parseInt(value);
        if (isNaN(longValue)) return 0;

        return longValue;
    }

    correlate() {
        this.confirmationService.confirm({
            //target: event.target as EventTarget,
            message:
                'Θέλετε να Συσχετίσετε το Παραστατικό την εγγραφή του Ψηφιακού Παλατολογίου?',
            // header: 'Επιβεβαίωση',
            defaultFocus: 'reject',
            closable: false,
            closeOnEscape: true,
            icon: 'pi pi-question',
            rejectButtonProps: {
                label: 'Ακύρωση',
                severity: 'secondary',
                outlined: true
            },
            acceptButtonProps: {
                label: 'Συσχέτιση',
                outlined: true
            },
            accept: () => {
                const invoiceDialogOptionsData = this.dialogConfigDataOptions
                    .data as InvoiceOptions;

                debugger;
                const invoice = this.invoiceFormGroup()?.getRawValue() as
                    | InvoiceType
                    | undefined;
                this.loaderService.showAwaitLoader();
                this.dclCardService
                    .correlateDigitalClientCard(
                        invoiceDialogOptionsData.dclCard,
                        invoice, //this.invoice(),
                        undefined
                    )
                    .pipe(
                        finalize(() => {
                            this.loaderService.dismissAwaitLoader();
                            const options = this.dialogConfigDataOptions
                                .data as InvoiceOptions;

                            const invoice =
                                this.invoiceFormGroup()?.getRawValue() as
                                    | InvoiceType
                                    | undefined; //const invoice = this.invoice();
                            if (invoice != undefined)
                                options.onCorrelationCompleted?.(
                                    invoice,
                                    options.selectedInvoiceTab?.()
                                );
                        })
                    )
                    .subscribe();
            },
            reject: () => {
                // this.messageService.add({
                //     severity: 'error',
                //     summary: 'Rejected',
                //     detail: 'You have rejected',
                //     life: 3000,
                // });
            }
        });
    }

    /**
     * Κουμπάκι 'Πληρωμή & Έκδοση Παραστατικού'.
     * ζητάει Τρόπο Πληρωμής
     */
    doSendToAADE(event: Event) {
        //const options = this.dialogConfig.data as InvoiceOptions;

        // Την διαβίβαση θα την ολοκληρώσει η επιλογή πληρωμής.
        // const options = this.dialogConfigDataOptions.data as InvoiceOptions;
        // if (
        //     options.selectedInvoiceTab?.() == 'products' &&
        //     options.invoiceCardTypeFormGroups?.[0]?.getRawValue()?.Response
        //         ?.InvoiceMark == undefined
        // ) {
        //     this.messageService.add({
        //         summary: 'Πληρωμή & Έκδοση Παραστατικού',
        //         detail: 'Δεν επιτρέπεται η έκδοση Παραστατικού Πώλησης αν δεν έχει προηγηθεί η έκδοση Παραστατικού Παροχής Υπηρεσιών.',
        //         severity: 'error',
        //         key: 'br'
        //     } as ToastMessageOptions);
        //     return;
        // }

        // Πρώτα αποθηκεύουμε ότι έχουμε φτιάξει
        // και μετά επιλέγουμε τρόπο πληρωμής
        this.onSave(true);

        //this.loaderService.showAwaitLoader();

        // Post and save both of the invoices
        // this.store
        //     .dispatch([
        //         new InvoiceGraphQLSchemaActions.Upsert(
        //             options.invoiceCardTypeFormGroups?.[0]?.getRawValue() as InvoiceInputType,
        //             undefined,
        //             InvoiceTypeQuery.GQLQuery()
        //         )
        //     ])
        //     .pipe(
        //         concatMap(() => {
        //             const invoice = this.store.selectSnapshot(
        //                 InvoiceGraphQLSchemaSelectors.UpsertSelector('', '')
        //             )?.data?.Upsert;

        //             return zip([
        //                 this.store.dispatch(
        //                     new InvoiceGraphQLSchemaActions.Upsert(
        //                         options.invoiceCardTypeFormGroups?.[1]?.getRawValue() as InvoiceInputType,
        //                         undefined,
        //                         InvoiceTypeQuery.GQLQuery()
        //                     )
        //                 ),
        //                 of(invoice)
        //             ]).pipe(
        //                 concatMap((value) => {
        //                     const invoice2 = this.store.selectSnapshot(
        //                         InvoiceGraphQLSchemaSelectors.UpsertSelector(
        //                             '',
        //                             ''
        //                         )
        //                     )?.data?.Upsert;
        //                     return of([value[1], invoice2]);
        //                 })
        //             );
        //         }),
        //         finalize(() => this.loaderService.dismissAwaitLoader())
        //     )
        //     .subscribe((updatedInvoices) => {
        //         // Θέλουμε το Observable γιατί πρώτα πρέπει να γίνουν save τα παραστατικά, να ενημερωθεί το Modal και μετά να προχωρήσουμε στον τρόπο πληρωμής και έκδοσης παραστατικού.
        //         options
        //             .onRefreshInvoices?.(options, updatedInvoices)
        //             .subscribe(() => {
        //                 this.selectPaymentOption(true);
        //             });
        //     });

        // // Αν εχεις προέλθει από το κουμπάκι 'Έξοδος Οχήματος' τότε ΥΠΟΧΡΕΩΤΙΚΆ ο χρήστης πρέπει να επιλέξει τρόπο πληρωμής.
        // if (options.sourceModal == true) {
        //     // Την διαβίβαση θα την ολοκληρώσει η επιλογή πληρωμής.
        //     this.selectPaymentOption(true);
        //     return;
        // }

        // this.confirmationService.confirm({
        //     //target: event.target as EventTarget,
        //     message:
        //         'Θέλετε να Εκδώσετε και να Διαβιβάσετε το παραστατικό στην Α.Α.Δ.Ε;',
        //     // header: 'Επιβεβαίωση',
        //     defaultFocus: 'reject',
        //     closable: false,
        //     closeOnEscape: true,
        //     icon: 'pi pi-question',
        //     rejectButtonProps: {
        //         label: 'Ακύρωση',
        //         severity: 'secondary',
        //         outlined: true
        //     },
        //     acceptButtonProps: {
        //         label: 'Έκδοση & Διαβίβαση',
        //         outlined: true
        //     },
        //     accept: () => {
        //         // this.messageService.add({
        //         //     severity: 'info',
        //         //     summary: 'Confirmed',
        //         //     detail: 'You have accepted'
        //         // });
        //         timer(100).subscribe(() => {
        //             this.onSendToAADE(false);
        //         });
        //     },
        //     reject: () => {
        //         // this.messageService.add({
        //         //     severity: 'error',
        //         //     summary: 'Rejected',
        //         //     detail: 'You have rejected',
        //         //     life: 3000,
        //         // });
        //     }
        // });
    }

    /**
     * Διαβίβαση Παραστατικού στην Α.Α.Δ.Ε μέσω του παρόχου.
     */
    SendToAADE(invoice: InvoiceType | undefined, askConfirmation: boolean) {
        if (this.showSendToAADEButton != true) return;

        if (!askConfirmation) {
            this.SendToAADEConfirmed(invoice);
        } else {
            const invoiceTypeDescriptionMappings = new Map<string, string>();
            invoiceTypeDescriptionMappings.set('11.1', 'Απόδειξη Πώλησης');
            invoiceTypeDescriptionMappings.set(
                '11.2',
                'Απόδειξη Παροχής Υπηρεσιών'
            );
            invoiceTypeDescriptionMappings.set(
                '2.1',
                'Τιμολόγιο Παροχής Υπηρεσιών'
            );
            invoiceTypeDescriptionMappings.set('1.1', 'Τιμολόγιο Πώλησης');
            invoiceTypeDescriptionMappings.set(
                '1.1-9.3',
                'Τιμολόγιο Πώλησης / Δελτίο Αποστολής'
            );
            invoiceTypeDescriptionMappings.set('9.3', 'Δελτίο Αποστολής');
            invoiceTypeDescriptionMappings.set(
                '11.4',
                'Πιστωτικό Στοιχ. Λιανικής'
            );
            invoiceTypeDescriptionMappings.set('5.2', 'Πιστωτικό Τιμολόγιο');

            this.confirmationService.confirm({
                //target: event.target as EventTarget,
                message: `Θέλετε να Εκδώσετε και να Διαβιβάσετε το παραστατικό '${invoiceTypeDescriptionMappings.get(invoice?.TypeCode ?? '')}' αξίας ${new ZCurrencyPipe().transform(invoice?.Summaries?.[0]?.TotalGrossValue)} στην Α.Α.Δ.Ε;`,
                // header: 'Επιβεβαίωση',
                defaultFocus: 'reject',
                closable: false,
                closeOnEscape: true,
                icon: 'pi pi-question',
                rejectButtonProps: {
                    label: 'Ακύρωση',
                    severity: 'secondary',
                    outlined: true
                },
                acceptButtonProps: {
                    label: 'Έκδοση & Διαβίβαση'
                    // outlined: true
                },
                accept: () => {
                    this.SendToAADEConfirmed(invoice);
                },
                reject: () => {
                    // this.messageService.add({
                    //     severity: 'error',
                    //     summary: 'Rejected',
                    //     detail: 'You have rejected',
                    //     life: 3000,
                    // });
                }
            });
        }
    }

    SendToAADEConfirmed(invoice: InvoiceType | undefined) {
        const invoiceDialogOptionsData = this.dialogConfigDataOptions
            .data as InvoiceOptions;
        // const formRawValue = cloneDeep(
        //   this.customerInvoiceFormComponent?.formGroup?.getRawValue() as InvoiceType,
        // );

        debugger;

        // ΝΟΤΕ: Με την τρέχουσα υλοποίηση ήδη κρατάμε τα στοιχεία του πελάτη στο πεδίο COunterPart.
        //       Αυτό το πετύχαμε γιατί κατά την επιλογή το υπελάτη γεμίζουμε τα πεδία αυτά.

        // // Κατά την έκδοση του παραστατικού πρέπει να κρατήσουμε τα στοιχεία της διεύθυνσης του Counter Part της στιγμής που εκδίδουμε το παραστατικό.
        // if (formRawValue.CounterPart?.CustomerId != undefined) {
        //   if (formRawValue.CounterPart?.Address) {
        //     formRawValue.CounterPart.Address.PostalCode =
        //       this.invoice()?.Customer?.Addresses?.[0]?.PostalCode?.trim() ?? '';

        //     formRawValue.CounterPart.Address.CityEx =
        //       this.invoice()?.Customer?.Addresses?.[0]?.CityEx ??
        //       this.invoice()?.Customer?.Addresses?.[0]?.City?.Title ??
        //       '';

        //     formRawValue.CounterPart.Address.StreetName =
        //       this.invoice()?.Customer?.Addresses?.[0]?.StreetName ?? '';

        //     formRawValue.CounterPart.Address.StreetNumber =
        //       this.invoice()?.Customer?.Addresses?.[0]?.StreetNumber ?? '';
        //   }

        //   if (formRawValue.DeliveryNodeHeader?.DeliveryAddress) {
        //     formRawValue.DeliveryNodeHeader.DeliveryAddress.CityEx =
        //       formRawValue.CounterPart?.Address?.CityEx ??
        //       this.invoice()?.Customer?.Addresses?.[0]?.CityEx ??
        //       this.invoice()?.Customer?.Addresses?.[0]?.City?.Title ??
        //       '';

        //     formRawValue.DeliveryNodeHeader.DeliveryAddress.PostalCode =
        //       formRawValue.CounterPart?.Address?.PostalCode ??
        //       this.invoice()?.Customer?.Addresses?.[0]?.PostalCode ??
        //       '';
        //   }
        // }

        // if (formRawValue.CounterPart?.SupplierId != undefined) {
        //   if (formRawValue.CounterPart?.Address) {
        //     formRawValue.CounterPart.Address.PostalCode =
        //       this.invoice()?.Supplier?.Addresses?.[0]?.PostalCode?.trim() ?? '';

        //     formRawValue.CounterPart.Address.CityEx =
        //       this.invoice()?.Supplier?.Addresses?.[0]?.CityEx ??
        //       this.invoice()?.Supplier?.Addresses?.[0]?.City?.Title ??
        //       '';

        //     formRawValue.CounterPart.Address.StreetName =
        //       this.invoice()?.Supplier?.Addresses?.[0]?.StreetName ?? '';

        //     formRawValue.CounterPart.Address.StreetNumber =
        //       this.invoice()?.Supplier?.Addresses?.[0]?.StreetNumber ?? '';
        //   }

        //   if (formRawValue.DeliveryNodeHeader?.DeliveryAddress) {
        //     formRawValue.DeliveryNodeHeader.DeliveryAddress.CityEx =
        //       formRawValue.CounterPart?.Address?.CityEx ??
        //       this.invoice()?.Supplier?.Addresses?.[0]?.CityEx ??
        //       this.invoice()?.Supplier?.Addresses?.[0]?.City?.Title ??
        //       '';

        //     formRawValue.DeliveryNodeHeader.DeliveryAddress.PostalCode =
        //       formRawValue.CounterPart?.Address?.PostalCode ??
        //       this.invoice()?.Supplier?.Addresses?.[0]?.PostalCode ??
        //       '';
        //   }
        // }

        this.loaderService.showAwaitLoader('Έκδοση & Διαβίβαση Παραστατικού');

        // const invoice = {
        //     ...options.invoiceCardTypeFormGroup?.getRawValue()
        // } as InvoiceInputType;

        debugger;
        if (invoice) {
            // Μην στείλεις τις εγγραφές που δεν έχουν περιγραφή!!!!
            invoice.Details = invoice.Details?.filter(
                (detail) => (detail.Descr ?? '').trim() != ''
            );
        }

        console.debug('Sending Invoice to A.A.D.E', {
            invoice,
            dialogConfig: this.dialogConfigDataOptions
        });
        // const invoice = {
        //   ...this.invoice(),
        //   ...formRawValue,
        // } as InvoiceType;

        debugger;

        if (invoice != undefined) {
            this.store
                .dispatch(
                    // Αποθήκευσε το Παραστατικό
                    new InvoiceGraphQLSchemaActions.Upsert(
                        invoice,
                        undefined,
                        queryForEdit
                    )
                )
                .pipe(
                    concatMap((value) => {
                        const upsertedInvoice = this.store.selectSnapshot(
                            InvoiceGraphQLSchemaSelectors.UpsertSelector('', '')
                        )?.data.Upsert;

                        invoice._id = upsertedInvoice?._id;
                        invoice.Stamp = upsertedInvoice?.Stamp;

                        debugger;
                        if (upsertedInvoice)
                            invoiceDialogOptionsData.onSaved?.(
                                upsertedInvoice,
                                invoiceDialogOptionsData.selectedInvoiceTab?.()
                            );

                        // Διαβιβάζουμε το παραστατικό στο πάροχο ηλεκτρονικής τιμολόγησης για να γίνει η διαβίβαση στην Α.Α.Δ.Ε.
                        // Αν όμως ο τρόπος πληρωμής είναι Κάρτα τότε ΔΕΝ θα γίνει διαβίβαση στην Α.Α.Δ.Ε
                        // αλλά θα δημιουργηθεί ένα POSTransaction αντικείμενο το οποίο πρέπει να χρησιμοποιήσει το τερματικό της τράπεζας για να δεχθεί την πληρωμή.
                        return this.postInvoicesToAADESchema
                            .PostInvoicesToAADE(invoice, queryForEdit)
                            .pipe(
                                concatMap((postedInvoice) => {
                                    invoiceDialogOptionsData.invoiceCardTypeFormGroup?.markAsPristine();
                                    invoiceDialogOptionsData.invoiceCardTypeFormGroup?.markAsUntouched();

                                    // Eπιστρέφουμε την απάντηση από την Αποστολή του παραστατικού στην Α.Α.Δ.Ε
                                    return of(
                                        postedInvoice?.data.PostInvoicesToAADE
                                    );
                                    //   return invoice != undefined
                                    //     ? this.fetchDataById('edit', invoice)
                                    //     : of(invoice);
                                })
                            );
                    }),
                    finalize(() => {
                        this.loaderService.dismissAwaitLoader();
                    })
                )
                .subscribe((invoice) => {
                    if (invoice)
                        invoiceDialogOptionsData.onSaved?.(
                            invoice,
                            invoiceDialogOptionsData.selectedInvoiceTab?.()
                        );

                    console.debug('Invoice sent to A.A.D.E', invoice);
                    const error = invoice?.Response?.Errors?.[0];

                    if (error != undefined) {
                        console.error(
                            'Failed to send invoice to A.A.D.E',
                            invoice?.Response?.Errors
                        );

                        this.messageService.add({
                            detail:
                                error?.Error?.[0]?.Message ??
                                `Σφάλμα Επικοινωνίας  ${invoice?.Response?.StatusCode}`,
                            //text: error?.Error?.[0]?.Message,
                            summary:
                                'Αποτυχία Διαβιβάσης Παραστατικού στην Α.Α.Δ.Ε',
                            severity: 'error',
                            key: 'br'
                        } as ToastMessageOptions);

                        return;
                    }

                    debugger;
                    if (
                        // Αν η απάντηση από τον πάροχο είναι με StatusCode == undefined και με InvoiceMark == 0 και έχουμε Signatures
                        // τότε ζητάμε πληρωμή με τερματικό.
                        // Αυτό θα μπορούσαμε να το δούμε και από τον τύπο, αλλά καλού κακού ας το δούμε με αυτές τις 3 μεταβλητές.
                        invoice?.Response?.StatusCode == undefined &&
                        invoice?.Response?.InvoiceMark == 0 &&
                        (invoice?.Response?.Signatures ?? []).length > 0
                    ) {
                        // this.validateFormButtons();

                        // options.onSentToAADE?.(options, invoice);

                        this.messageService.add({
                            detail: 'Το παραστατικό είναι σε κατάσταση Αναμονής. Ακολουθεί επικοινωνία με Τερματικό Αποδοχής Καρτών (POS) για εξόφληση παραστατικού.',
                            //text: error?.Error?.[0]?.Message,
                            summary: 'Εκδοση Παραστατικού.',
                            severity: 'warn',
                            key: 'br'
                        } as ToastMessageOptions);

                        // Επιστροφή με Υπογραφές για αποστολή στο τερματικό και αποδοχή πληρωμής.
                        // Εδώ η μεταβλητή invoice Πρέπει να έχει μια λίστα με όλα τα POSTransactions!!!
                        //
                        // Εδώ καλούμε την doPOSTransaction για να περιμενουμε απλά απάντηση. Απάντηση όχι από το τερματικό το ίδιο, αλλά από το τερματικό μέσω της βάσης.
                        if (invoice) {
                            timer(300).subscribe(() => {
                                // Η ανανέωση του DCL Cards θα γινει μέσα από την doPOSTransaction καλώντας αυτό options.onSentToAADE?.(options, invoice);
                                this.doPOSTransaction(invoice);
                            });
                        } else {
                            this.messageService.add({
                                detail: 'Το παραστατικό Εκδόθηκε επιτυχώς Αλλά δεν έγινε δυνατόν να ανακτηθεί από τη βάση. Η Επικοινωνία με Τερματικό Αποδοχής Καρτών (POS) τερματίζεται.',
                                //text: error?.Error?.[0]?.Message,
                                summary: 'Εκδοση Παραστατικού.',
                                severity: 'error',
                                key: 'br'
                            } as ToastMessageOptions);
                        }

                        return;
                    }

                    const statusCode =
                        invoice?.Response?.StatusCode?.toLocaleLowerCase();

                    if (statusCode == 'success' || statusCode == 'offline') {
                        this.messageService.add({
                            detail: 'Το παραστατικό Εκδόθηκε και Διαβιβάστηκε στην Α.Α.Δ.Ε επιτυχώς.',
                            summary:
                                'Επιτυχής Διαβιβάση Παραστατικού στην Α.Α.Δ.Ε',
                            severity: 'success',
                            key: 'br'
                        } as ToastMessageOptions);

                        debugger;
                        timer(300).subscribe(() => {
                            if (invoice)
                                invoiceDialogOptionsData.onSentToAADE?.(
                                    invoiceDialogOptionsData,
                                    invoice
                                );
                        });

                        // this.postInvoicesToAADESchema
                        //     .AskSignatureForOldInvoice(
                        //         invoice,
                        //         InvoiceTypeQuery.GQLQuery({
                        //             Response:
                        //                 ProviderResponseTypeQuery.GQLQuery({
                        //                     Errors: ResponseTypeErrorTypeQuery.GQLQuery(
                        //                         {
                        //                             Error: ProviderResponseErrorTypeQuery.GQLQuery()
                        //                         }
                        //                     )
                        //                 })
                        //         })
                        //     )
                        //     .subscribe((response) => {
                        //         debugger;
                        //     });
                    } else {
                        console.error(
                            'Failed to send invoice to A.A.D.E but not with erros from provider',
                            invoice
                        );

                        this.messageService.add({
                            detail: `Σφάλμα Επικοινωνίας. Η διαβίβαση δεν έχει ολοκληρωθεί επιτυχώς (Statuscode != Success). Δείτε τα Log Files.`,
                            //text: error?.Error?.[0]?.Message,
                            summary:
                                'Αποτυχία Διαβιβάσης Παραστατικού στην Α.Α.Δ.Ε',
                            severity: 'error',
                            key: 'br'
                        } as ToastMessageOptions);

                        return;
                    }
                    //if (invoice) this.rowsToUpdate.set([invoice]);
                });

            // this.postInvoicesToAADESchema
            //   .PostInvoicesToAADE(invoice, InvoiceTypeQuery.GQLQuery())
            //   .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
            //   .subscribe(() => {
            //     this.customerInvoiceFormComponent?.formGroup?.markAsPristine();
            //     this.customerInvoiceFormComponent?.formGroup?.markAsUntouched();

            //     if (invoice != undefined) {
            //       this.fetchDataById('edit', invoice);
            //       this.rowsToUpdate.set([invoice]);
            //     }
            //   });
        }
    }

    hex2Base64(hexValue: string): string {
        if (hexValue.length % 2 !== 0) {
            hexValue = '0' + hexValue;
        }

        const bytes = new Uint8Array(hexValue.length / 2);
        for (let i = 0; i < bytes.length; i++) {
            const byteString = hexValue.substring(2 * i, 2 * i + 2);
            bytes[i] = parseInt(byteString, 16);
        }

        // Convert bytes to base64
        let binary = '';
        bytes.forEach((b) => (binary += String.fromCharCode(b)));
        return btoa(binary); // btoa is available in browsers; use Buffer in Node.js
    }
}

const queryForEdit: InvoiceTypeQuery = {
    ...InvoiceTypeQuery.GQLQuery(),
    UsersActions: UsersActionsTypeQuery.GQLQuery(),
    CounterPart: InvoicePartyTypeQuery.GQLQuery({
        ...InvoicePartyTypeQuery.GQLQuery(),
        Address: AddressTypeQuery.GQLQuery({
            City: CityTypeQuery.GQLQuery()
        }),
        Customer: CustomerTypeQuery.GQLQuery({
            ...CustomerTypeQuery.GQLQuery(),
            FirstName: FirstNameTypeQuery.GQLQuery()
        }),
        Supplier: SupplierTypeQuery.GQLQuery({
            ...CustomerTypeQuery.GQLQuery(),
            FirstName: FirstNameTypeQuery.GQLQuery(),
            Addresses: AddressTypeQuery.GQLQuery({
                City: CityTypeQuery.GQLQuery()
            })
        })
    }),
    Issuer: InvoicePartyTypeQuery.GQLQuery({
        ...InvoicePartyTypeQuery.GQLQuery(),
        Address: AddressTypeQuery.GQLQuery({}),
        Customer: CustomerTypeQuery.GQLQuery({
            ...CustomerTypeQuery.GQLQuery(),
            FirstName: FirstNameTypeQuery.GQLQuery()
        }),
        Supplier: SupplierTypeQuery.GQLQuery({
            ...CustomerTypeQuery.GQLQuery(),
            FirstName: FirstNameTypeQuery.GQLQuery()
        })
    }),
    Courier: CourierTypeQuery.GQLQuery(),
    Customer: CustomerTypeQuery.GQLQuery({
        ...CustomerTypeQuery.GQLQuery(),
        FirstName: FirstNameTypeQuery.GQLQuery(),
        Addresses: AddressTypeQuery.GQLQuery({
            City: CityTypeQuery.GQLQuery()
        }),
        ContactDetails: ContactDetailTypeQuery.GQLQuery(),
        Courier: CourierTypeQuery.GQLQuery(),
        DicsountCategory: DiscountCategoryTypeQuery.GQLQuery(),
        CTAXOffice: TAXOfficeTypeQuery.GQLQuery()
    }),
    Supplier: SupplierTypeQuery.GQLQuery({
        Addresses: AddressTypeQuery.GQLQuery({
            City: CityTypeQuery.GQLQuery()
        }),
        ContactDetails: ContactDetailTypeQuery.GQLQuery(),
        FirstName: FirstNameTypeQuery.GQLQuery()
    }),
    DeliveryNodeHeader: InvoiceDeliveryNoteHeaderTypeQuery.GQLQuery({
        DeliveryAddress: AddressTypeQuery.GQLQuery({
            City: CityTypeQuery.GQLQuery()
        }),
        LoadingAddress: AddressTypeQuery.GQLQuery({
            City: CityTypeQuery.GQLQuery()
        })
    }),
    Details: InvoiceDetailTypeQuery.GQLQuery({
        ProductPackage: ProductPackageTypeQuery.GQLQuery({
            InventoriesList: ProductInventoryInfoTypeQuery.GQLQuery(),
            InvoicingList: ProductInvoicingInfoTypeQuery.GQLQuery()
        })
    }),
    Incomes: InvoiceIncomeClassificationTypeQuery.GQLQuery(),
    Notes: InvoiceNoteTypeQuery.GQLQuery(),
    Response: ProviderResponseTypeQuery.GQLQuery({
        Errors: ResponseTypeErrorTypeQuery.GQLQuery({
            Error: ProviderResponseErrorTypeQuery.GQLQuery()
        }),
        Signatures: SignatureInvoiceResponseTypeQuery.GQLQuery({
            Signatures: ProviderSignatureTypeQuery.GQLQuery({
                SignatureMoreData: ProviderSignatureMoreDataTypeQuery.GQLQuery()
            })
        })
    }),
    POSTransactions: POSTerminalTransactionTypeQuery.GQLQuery({
        UsersActions: UsersActionsTypeQuery.GQLQuery(),
        InvoicePayment: InvoicePaymentTypeQuery.GQLQuery(),
        TransactionData: POSTerminalTransactionDataTypeQuery.GQLQuery(),
        ServiceData: POSTerminalServiceDataTypeQuery.GQLQuery(),

        Responses: POSTerminalResponseTypeQuery.GQLQuery({
            TransactionData: POSTerminalTransactionDataTypeQuery.GQLQuery(),
            Error: POSTerminalErrorDataTypeQuery.GQLQuery()
        })
    }),

    //Responses: ProviderResponseTypeQuery.GQLQuery(),
    SubjectsInfos: InvoiceEntitySubjectInfoTypeQuery.GQLQuery(),
    Summaries: InvoiceSummaryTypeQuery.GQLQuery(),
    Taxes: InvoiceTaxTypeQuery.GQLQuery(),
    Payments: InvoicePaymentTypeQuery.GQLQuery()
};

const queryForBatch: InvoiceTypeQuery = {
    ...InvoiceTypeQuery.GQLQuery(),

    CounterPart: InvoicePartyTypeQuery.GQLQuery({
        ...InvoicePartyTypeQuery.GQLQuery(),
        Address: AddressTypeQuery.GQLQuery(),
        Customer: CustomerTypeQuery.GQLQuery({
            ...CustomerTypeQuery.GQLQuery(),
            FirstName: FirstNameTypeQuery.GQLQuery()
        }),
        Supplier: SupplierTypeQuery.GQLQuery({
            ...CustomerTypeQuery.GQLQuery(),
            FirstName: FirstNameTypeQuery.GQLQuery()
        })
    }),
    Issuer: InvoicePartyTypeQuery.GQLQuery({
        ...InvoicePartyTypeQuery.GQLQuery(),
        Address: AddressTypeQuery.GQLQuery(),
        Customer: CustomerTypeQuery.GQLQuery({
            ...CustomerTypeQuery.GQLQuery(),
            FirstName: FirstNameTypeQuery.GQLQuery()
        }),
        Supplier: SupplierTypeQuery.GQLQuery({
            ...CustomerTypeQuery.GQLQuery(),
            FirstName: FirstNameTypeQuery.GQLQuery()
        })
    }),
    Courier: CourierTypeQuery.GQLQuery(),
    DeliveryNodeHeader: InvoiceDeliveryNoteHeaderTypeQuery.GQLQuery(),
    Details: InvoiceDetailTypeQuery.GQLQuery(),
    Incomes: InvoiceIncomeClassificationTypeQuery.GQLQuery(),
    Notes: InvoiceNoteTypeQuery.GQLQuery(),
    Response: ProviderResponseTypeQuery.GQLQuery({
        Errors: ResponseTypeErrorTypeQuery.GQLQuery({
            Error: ProviderResponseErrorTypeQuery.GQLQuery()
        })
    }),
    //Responses: ProviderResponseTypeQuery.GQLQuery(),
    SubjectsInfos: InvoiceEntitySubjectInfoTypeQuery.GQLQuery(),
    Summaries: InvoiceSummaryTypeQuery.GQLQuery(),
    Taxes: InvoiceTaxTypeQuery.GQLQuery(),
    Payments: InvoicePaymentTypeQuery.GQLQuery()
};
